// extracted by mini-css-extract-plugin
export default {"mobileOnly":"MobileMessage_mobileOnly__OYAD1"};